export default "/_next/static/4810f25c259b1209e51e70b930506e3f.svg";